// Kilat 4U build logic: pure, never throws, money in integer cents.
const A = x => Array.isArray(x) ? x.filter(Boolean) : [];
const S = x => typeof x == 'number' || typeof x == 'string' ? '' + x : '';
const D = x => /^\d+$/.test(S(x)) && Number.isSafeInteger(+x) ? +x : 0;
const uniq = a => [...new Set(a)];
const sum = (a, k) => a.reduce((t, x) => t + x[k], 0);
const ok = x => x.a !== false;
const M = /^(f4|p6)$/i;
const fk = p => Array.isArray(p.fits);
const fits = (p, k) => !fk(p) || p.fits.includes(k);
const T = (p, v) => S(A(p.v).length > 1 ? p.t + ' - ' + v.t : p.t).replace(/\s+/g, ' ').trim();
const slot = (c, id) => A(c.slots).find(s => s.id === id && (id != 'mix' || c.mix === true)) || {}; // {} = the page does not show it
const cap = (s, n) => s.length <= n ? s : s.slice(0, n + 1).replace(/[ ,]*[^ ,]*$/, '') || s.slice(0, n);
const fitList = (a, n) => { const all = a.join(', '); if (all.length <= n) return all; let s = a[0], i = 1; while (i < a.length && (s + ', ' + a[i]).length <= n - 4) s += ', ' + a[i++]; return cap(s, n - 4) + ' +' + (a.length - i); }; // cut between items and say how many are left

// The words. The page brings the visitor's language as cat.t (key -> text, or {one, other}) and cat.lang (see the
// data-k4u-build-data island). EN is today's English, the same text as locales/en.default.json: it answers when there is no island
// or a key is missing, so a shopper never sees a key name. The diagnostics in warnings / dropped stay English: they are never shown.
const EN = {
  'build.line_machine_set': 'Lutian {{ name }} + 3-Step Set',
  'build.summary_machine_set': '{{ name }} + 3-Step Set',
  'build.summary_bottles': { one: '{{ name }} + {{ count }} bottle', other: '{{ name }} + {{ count }} bottles' },
  'build.nudge_two': 'Add the other two: {{ delta }}',
  'build.nudge_third': 'Add the third: {{ delta }}',
  'build.nudge_none': '{{ delta }} with your washer',
  'build.fit_to_confirm': '(fit to confirm)',
  'wa.not_sure': "Hi Kilat 4U, I'm not sure which washer to get. My vehicle is:",
  'wa.build_header': "Hi Kilat 4U, I'd like to order this build ({{ code }}):",
  'wa.build_line': '- {{ title }}: {{ price }}',
  'wa.more_parts': '- +{{ count }} more parts',
  'wa.more_parts_link': '- +{{ count }} more parts, see the build link',
  'wa.build_total': 'Total: {{ amount }} (Sarawak delivery)',
  'wa.delivery_to': 'Delivery to (town):',
  'wa.ask_name': 'My name:',
  'wa.ask_where': 'Deliver to (town), or pick up in Bintulu:',
  'wa.extras_note': '(Extras are on top of the standard parts.)',
  'wa.build_link': 'My build:'
};
const dec = s => s.replace(/&#39;|&#x27;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); // Liquid's t filter HTML-escapes
const fmt = (s, v) => S(s).replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (v && k in v ? v[k] : m));
const rule = (c, n) => { try { return new Intl.PluralRules((c && c.lang) || 'en').select(n); } catch { return 'other'; } };
const word = (c, k, n) => {
  for (const o of [c && c.t, EN]) { // the island first, then English; a key missing from Liquid's output is a text, not a key
    let x = o && o[k];
    if (x && typeof x == 'object') x = x[rule(c, n)] || x.other;
    if (typeof x == 'string' && x && !/^translation missing/i.test(x)) return o === EN ? x : dec(x);
  }
  return '';
};
const tx = (c, k, v) => fmt(word(c, k), v);
const pl = (c, k, n, v) => fmt(word(c, k, n), { count: n, ...v });
const enc = s => { try { return encodeURIComponent(s).length; } catch { return 1 / 0; } }; // a lone surrogate cannot be encoded

export const money = c => {
  c = Math.round(Number(c));
  c = isFinite(c) ? c : 0;
  return (c < 0 ? '-RM' : 'RM') + (Math.abs(c) / 100).toLocaleString('en', { minimumFractionDigits: c % 100 ? 2 : 0 });
};

const canon = s => (s = s || {}, [S(s.machine), uniq(A(s.bottles).map(S)).sort(), uniq(A(s.parts).map(D)).filter(Boolean).sort((a, b) => a - b)]);

export const fingerprint = s => {
  const [m, l, u] = canon(s), h = [...m + '|' + l.join('') + '|' + u].reduce((h, c) => Math.imul(h ^ c.charCodeAt(0), 16777619), 2166136261);
  return 'K4U-' + (h >>> 0).toString(36).toUpperCase().padStart(4, '0').slice(-4);
};

export const encode = s => {
  const [m, l, u] = canon(s), d = l.join('').replace(/\D/g, '');
  return [M.test(m) && 'm=' + m.toLowerCase(), d && 'l=' + d, u.length && 'u=' + u].filter(Boolean).join('&');
};

const norm = (st, cat) => {
  st = st || {};
  const w = [], bk = A(cat.bottles), pick = new Map(), m = A(cat.machines).find(x => x.k === st.machine && x.base) || null;
  const all = A(cat.parts).flatMap(p => A(p.v).map(v => ({ p, v }))), no = why => why && w.push(why);
  no(st.machine && !m && 'Unknown washer');
  const bots = uniq(A(st.bottles).map(S)).filter(k => !no(!bk.some(b => b.k === k) && 'Unknown bottle')).sort();
  no(!m && A(st.parts).length && 'Pick a washer first');
  for (const raw of m ? A(st.parts) : []) {
    const id = D(raw), f = all.find(x => x.v.id === id && slot(cat, x.p.slot).id);
    if (!no(!f ? 'Unknown part ' + id : !ok(f.v) ? T(f.p, f.v) + ' sold out' : !fits(f.p, m.k) && T(f.p, f.v) + ' does not fit the ' + m.n)) pick.set(slot(cat, f.p.slot).mode == 'one' ? f.p.slot : id, f);
  }
  const at = o => A(cat.slots).findIndex(s => s.id === o.p.slot), out = [...pick.values()].sort((a, b) => at(a) - at(b) || a.v.id - b.v.id);
  return { state: { machine: m && m.k, bottles: bots, parts: out.map(o => o.v.id) }, w, m, out };
};

export const normalize = (st, cat) => { const n = norm(st, cat || {}); return { state: n.state, warnings: n.w }; };

export function resolve(st, cat) {
  cat = cat || {};
  const { state: s, w, m, out } = norm(st, cat), bk = A(cat.bottles), sel = bk.filter(b => s.bottles.includes(b.k)), nb = sel.length;
  const set = m && m.set && ok(m.set) && m.set, canSet = !!set && bk.length == 3, setMode = canSet && nb == 3;
  const v = m && (setMode ? set : m.base), cost = canSet ? set.p - m.base.p : 0, lines = [], names = out.map(o => T(o.p, o.v));
  const add = (kind, id, title, price, more) => lines.push({ kind, id, qty: 1, title, price, ...more });
  if (m) {
    add('machine', v.id, setMode ? tx(cat, 'build.line_machine_set', { name: m.n }) : 'Lutian ' + m.n, v.p);
    if (!setMode) sel.forEach(b => (ok(b) || w.push(b.n + ' sold out'), add('bottle', b.id, b.n, b.p)));
    out.forEach((o, i) => add('part', o.v.id, names[i], o.v.p, !fk(o.p) && { fitUnknown: true }));
  }
  const code = fingerprint(s), nudge = { all: null, third: null }, spares = [];
  const summary = m ? fitList([setMode ? tx(cat, 'build.summary_machine_set', { name: m.n }) : nb ? pl(cat, 'build.summary_bottles', nb, { name: m.n }) : m.n, ...names], 120) : '';
  if (canSet && nb < 3) {
    const d = cost - sum(sel, 'p'), sg = x => (x > 0 ? '+' : '') + money(x);
    nudge.all = { text: nb ? tx(cat, ['build.nudge_two', 'build.nudge_third'][nb - 1], { delta: sg(d) }) : tx(cat, 'build.nudge_none', { delta: money(d) }), delta: d };
    if (nb == 2) nudge.third = { text: sg(d), delta: d, bottle: bk.find(b => !sel.includes(b)).k };
  }
  out.forEach(o => slot(cat, o.p.slot).mode == 'one' && A(cat.box).forEach(b => b.slot === o.p.slot && (b.m == m.k || b.m == 'both') && spares.push({ slot: b.slot, title: b.t })));
  if (m && !ok(v)) w.push(m.n + ' unavailable');
  if (nb == 3 && !setMode) w.push('No 3-Step Set, single bottles');
  return {
    state: s,
    machine: m && { k: m.k, h: m.h, n: m.n, url: m.url },
    variant: v && { id: v.id, p: v.p, a: ok(v), set: setMode },
    setMode,
    lines,
    items: lines.map((l, i) => ({ id: l.id, quantity: 1, properties: i ? { _build: code } : { _build: code, Build: summary } })),
    total: sum(lines, 'price'),
    saving: setMode ? { vsSet: Math.max(0, (+cat.setAlone || 0) - cost), vsSingles: Math.max(0, sum(bk, 'p') - cost) } : null,
    nudge, spares, warnings: w, summary, code
  };
}

// '#m=p6&l=12&u=1,2', '?m=f4', 'f4', '#p6', a whole URL
export function decode(str, cat) {
  const d = [], raw = { machine: null, bottles: [], parts: [] };
  let s = typeof str == 'string' ? str : '', u = [];
  if (s.length > 2000) { s = s.slice(0, 2000); d.push('Link too long'); }
  for (let t of s.toLowerCase().split(/[#?&]/)) {
    const [k, ...r] = (M.test(t = t.trim()) ? 'm=' + t : t).split('='), x = r.join('=');
    let v = x;
    try { v = decodeURIComponent(x).trim(); } catch { d.push('Bad characters in link'); }
    if (k == 'm') {
      raw.machine = M.test(v) ? v : null;
      if (v && !raw.machine) d.push('Unknown washer');
    } else if (k == 'l') raw.bottles = [...v.replace(/\D/g, '')];
    else if (k == 'u') u = v.split(',').map(x => x.trim()).filter(Boolean);
  }
  raw.parts = u.map(D).filter(Boolean);
  if (raw.parts.length < u.length) d.push('Bad item in link');
  const n = norm(raw, cat || {}), dropped = uniq(d.concat(n.w));
  return { state: n.state, dropped, changed: dropped.length > 0 || encode(raw) !== encode(n.state) };
}

export function waText(r, cat, link) {
  if (!r || !r.machine) return tx(cat, 'wa.not_sure') + ' ';
  const ls = A(r.lines), ps = ls.filter(l => l.kind == 'part'), f = l => tx(cat, 'wa.build_line', { title: l.title, price: money(l.price) }) + (l.fitUnknown ? ' ' + tx(cat, 'build.fit_to_confirm') : '');
  link = typeof link == 'string' ? link.replace(/\s/g, '') : '';
  const build = (k, u) => [
    tx(cat, 'wa.build_header', { code: r.code }), ...ls.filter(l => l.kind != 'part').map(f), ...ps.slice(0, k).map(f),
    ps.length > k && tx(cat, u || !link ? 'wa.more_parts_link' : 'wa.more_parts', { count: ps.length - k }), ps.length > 0 && tx(cat, 'wa.extras_note'),
    tx(cat, 'wa.build_total', { amount: money(r.total) }), tx(cat, 'wa.ask_name') + ' ', tx(cat, 'wa.ask_where') + ' ', u && tx(cat, 'wa.build_link') + ' ' + u
  ].filter(Boolean).join('\n');
  let t; // 900 characters, and 2000 once encoded for the address: a Chinese character is 9 of them
  for (const u of [link, '']) for (let k = Math.min(ps.length, 8); k >= 0; k--) if ((t = build(k, u)).length <= 900 && enc(t) <= 2000) return t;
  for (t = build(0, '').slice(0, 900).replace(/[\ud800-\udbff]$/, ''); enc(t) > 2000;) t = t.slice(0, -1).replace(/[\ud800-\udbff]$/, '');
  return t;
}

export function slotsFor(cat, key) {
  cat = cat || {};
  if (!key || typeof key != 'string') return [];
  return A(cat.slots).filter(s => slot(cat, s.id).id).map(s => {
    const stock = A(cat.box).filter(b => b.slot === s.id && (b.m == key || b.m == 'both'));
    const options = A(cat.parts).filter(p => p.slot === s.id && fits(p, key)).flatMap(p => A(p.v).map(v => ({
      partId: p.id, variantId: v.id, title: T(p, v), price: v.p, available: ok(v), fit: fk(p) ? 'yes' : 'unknown', img: p.img, cut: !!p.cut, ...(p.s && { sentence: p.s })
    })));
    return { ...s, state: options.length ? 'tab' : stock.length ? 'quiet' : 'hidden', stock, options, more: options.slice(2) };
  });
}

export function quickPicks(cat, key) {
  cat = cat || {};
  const ms = A(cat.machines), list = new Map();
  [...A(cat.pop), ...ms.map(m => ({ k: 'machine-' + m.k, n: 'Machine only', b: 'The washer and what comes in its box.', m: m.k }))].forEach(e => {
    const m = ms.find(x => x.k === e.m), tag = e.tag && 'build-' + S(e.tag).toLowerCase(), tagged = new Map();
    if (!m) return;
    A(cat.parts).forEach(p => { // a part with several variants is left to its own tab: nothing is priced silently
      const v = A(p.v);
      if (v.length == 1 && ok(v[0]) && !tagged.has(p.slot) && A(p.tags).some(t => S(t).toLowerCase() == tag) && fits(p, m.k)) tagged.set(p.slot, v[0].id);
    });
    const r = resolve({ machine: m.k, bottles: e.set ? A(cat.bottles).map(b => b.k) : [], parts: [...tagged.values()] }, cat), id = encode(r.state); // the whole state is the identity
    if (r.state.machine && r.state.parts.length >= (+e.min || 0) && !list.has(id)) list.set(id, { k: e.k, n: e.n, b: e.b, machine: m.k, set: r.setMode, price: r.total, state: r.state, selected: false });
  });
  return [...list.values()].sort((a, b) => (b.machine == key) - (a.machine == key));
}
